import AxiosInstance from "@/api/axios";
import { toast } from "@/components/Base/Toast/ToastManager";
import { ROLE } from "@/utils/enum";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export interface IUserManual {
  _id: string;
  reEngage: boolean;
  sales: boolean;
  role: keyof ROLE;
  userManual: {
    name: string;
    filename: string;
    fileType: string;
    s3Path: string;
    view: string;
    path: string;
  };
}

export const fetchUserManuals = createAsyncThunk(
  "fetchUserManuals/fetchData",
  async (_, thunkAPI) => {
    try {
      const response = await AxiosInstance.get(`/manual`);
      if (response.data.success) {
        return response.data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  },
);

export const createUserManual = createAsyncThunk(
  "createUserManuals/fetchData",
  async ({}, thunkAPI) => {
    try {
      const response = await AxiosInstance.get(`/manual`);
      if (response.data.success) {
        toast.show({
          title: "Changes saved successfully.",
          content: "User manual uploaded.",
          duration: 2000,
          type: "primary",
        });
        return response.data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      toast.show({
        title: "Changes saved successfully.",
        content: "User manual uploaded.",
        duration: 2000,
        type: "warning",
      });
      return null;
    }
  },
);

interface DeleteUserManuals {
  id: string;
}

export const deleteUserManual = createAsyncThunk(
  "deleteUserManual",
  async ({ id }: DeleteUserManuals) => {
    try {
      const response = await AxiosInstance.delete(`/manual/${id}`);
      if (response.data.success) {
        toast.show({
          title: "Changes saved successfully.",
          content: "User manual deleted",
          duration: 2000,
          type: "primary",
        });
        return response.data.data;
      }
    } catch (error) {
      toast.show({
        title: "Error",
        content: "Failed to delete file",
        duration: 2000,
        type: "warning",
      });
      return null;
    }
  },
);

interface IUserManualState {
  manuals: IUserManual[] | [];

  loading: boolean;
  error: string | null;
}

const initialState: IUserManualState = {
  manuals: [],
  loading: false,
  error: null,
};

const userManualReducer = createSlice({
  name: "userManuals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserManuals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserManuals.fulfilled, (state, action) => {
        state.loading = false;
        state.manuals = action.payload;
      })
      .addCase(fetchUserManuals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteUserManual.fulfilled, (state, action) => {
        const fileId = action.payload;
        if (state.manuals) {
          state.manuals = state.manuals.filter(
            (file: IUserManual) => file._id !== fileId,
          );
        }
      });
  },
});

export default userManualReducer.reducer;
